import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidatorFn
} from '@angular/forms';
import {
  Aggregator,
  AgpFormUtil,
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';

import { aggregator } from '@env/aggregator/aggregator';

@Component({
  selector: 'spark-shared-mobile-number',
  templateUrl: './mobile-number.component.html',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SparkSharedMobileNumberComponent),
      multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SparkSharedMobileNumberComponent),
      multi: true
    }
  ]
})
export class SparkSharedMobileNumberComponent
  extends CvaFormGroupComponent<string, string>
  implements OnChanges
{
  @Input() isRequired = false;
  @Input() label = 'Mobile number';
  @Input() allowLeadingZeros: boolean = true;

  form = new FormControl(null as string | null, [this.mobileNumberValidator()]);
  formGroup = new FormGroup({
    mobile: this.form
  });

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isRequired) {
      AgpFormUtil.Validators.updateRequiredIfNecessary(
        this.form,
        changes.isRequired.currentValue
      );
    }
  }

  protected reset(opts?: ResetOptions | undefined): void {
    this.form?.reset(undefined, opts);
  }

  protected transformToModel = (value: string): string =>
    value ? value.toString() : value;

  constructor() {
    super();
  }

  private mobileNumberValidator(): ValidatorFn {
    const pattern: RegExp =
      aggregator.name === Aggregator.MPM
        ? RegExp(/^\d{9,12}$/)
        : RegExp(/^\d{10,12}$/);
    return (control: AbstractControl): { [key: string]: string } | null => {
      const controlValue = control.value;
      if (!controlValue) {
        return null;
      }
      const isValid = pattern.test(controlValue);
      return isValid
        ? null
        : { mobileNumberValidator: 'Mobile number is invalid' };
    };
  }
}
